import { z } from '../utils/zod-extend'

const myPageTagTabUrlType = ['communityTalk', 'communitySns'] as const

export const mypageTagTabSchema = z.object({
  kind: z.literal('tag'),
  id: z.string(),
  tagId: z.string().min(1),
  label: z.string().max(13).optional(),
  enabled: z.boolean(),
  url: z.string().optional(),
  urlType: z.enum(myPageTagTabUrlType).optional(),
}).superRefine((data, ctx) => {
  // 遷移先URLが空でない場合、urlTypeは必須
  if (data.url && !data.urlType) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['urlType'],
      message: 'メニュータイプを選択してください',
    })
  }
})
export type MypageTagTab = z.infer<typeof mypageTagTabSchema>

export const mypageOtherTabSchema = z.object({
  kind: z.literal('other'),
  id: z.string(),
  label: z.string().optional(),
  enabled: z.boolean(),
})
export type MypageOtherTab = z.infer<typeof mypageOtherTabSchema>
export const defaultOtherTab: MypageOtherTab = { kind: 'other', id: 'other', label: 'その他', enabled: true }

export const MyPageTabSchema = z.union([mypageTagTabSchema, mypageOtherTabSchema])
export type MypageTab = z.infer<typeof MyPageTabSchema>

export function isTagTab(tab: Pick<MypageTab, 'kind'> | undefined | null): tab is MypageTagTab {
  return (!!tab && tab.kind === 'tag')
}

export function isOtherTab(tab: Pick<MypageTab, 'kind'> | undefined | null): tab is MypageOtherTab {
  return (!!tab && tab.kind === 'other')
}
